export enum ETypeQuery {
  ARTICLE = 'ARTICLE',
  BROADCAST = 'BROADCAST',
  NOTICE = 'NOTICE',
}
